import React, { FC, PropsWithChildren } from 'react'
import { ComboboxPopover } from '@ariakit/react'
import { styled, breakpoint, breakpointDown } from '@moonpig/launchpad-utils'
import { SEARCH_POPOVER_Z_INDEX } from '../constants'

const StyledComboboxPopover = styled(ComboboxPopover)<{
  popoverWidth?: number
}>`
  position: fixed;
  width: 100dvw;
  height: 100dvh;
  padding: 0;
  z-index: ${SEARCH_POPOVER_Z_INDEX};
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.colorBackground01};
  border: none;
  box-shadow: none;

  /* Override the transform to remove horizontal offset but keep vertical */
  ${breakpointDown('md')} {
    &[data-dialog] {
      transform: translate3d(-8px, 0px, 0px) !important;
    }
  }

  ${breakpoint('md')} {
    width: ${({ popoverWidth }) =>
      popoverWidth ? /* istanbul ignore next */ `${popoverWidth}px` : 'none'};
    height: auto;
    max-height: calc(100dvh - 48px);
    border-radius: 0 0 8px 8px;
  }
`

type Props = PropsWithChildren<{
  popoverWidth?: number
}>

export const Popover: FC<Props> = ({ popoverWidth, children }) => {
  return (
    <StyledComboboxPopover popoverWidth={popoverWidth} autoFocusOnHide={false}>
      {children}
    </StyledComboboxPopover>
  )
}
